/**
 * Practice rounds, as seen from the main bundle. The tutorial itself is a lazy
 * chunk (`src/tutorial/`); this file only knows which games have one and where it
 * lives. The only entry point is the Rules sheet's "Try a practice round".
 */
import type { GameId } from "./catalogue";

/** Games with a registered practice round (keep equal to `src/tutorial/registry.ts`). */
export const PRACTICE_GAMES: readonly GameId[] = ["impostor", "mafia", "secret-hitler", "alibi", "liar-dice", "spectrum"];

export const hasPractice = (id: string) =>
  (PRACTICE_GAMES as readonly string[]).includes(id);

export const practicePath = (id: string) => `/learn/${id}`;
